(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureAddPartSizeController', EditorStructureAddPartSizeController);

    EditorStructureAddPartSizeController.$inject = ['$scope', '$uibModalInstance'];

    function EditorStructureAddPartSizeController($scope, $uibModalInstance) {
        var vm = this;
        var ratio = 1;

        vm.size = { width: 100, height: 100 };
        vm.linked = false;
        vm.invalid = false;

        function ratioOf(size) {
            var width = parseFloat(size.width), height = parseFloat(size.height);
            return width > 0 && height > 0 ? width / height : 1;
        }

        $scope.toggleLink = function () {
            vm.linked = !vm.linked;
            if (vm.linked) {
                ratio = ratioOf(vm.size);
            }
        };

        $scope.onSizeChange = function (dimension) {
            vm.invalid = false;
            if (!vm.linked) {
                return;
            }
            var width = parseFloat(vm.size.width), height = parseFloat(vm.size.height);
            if (dimension === 'width' && width > 0) {
                vm.size.height = Math.max(1, Math.round(width / ratio));
            } else if (dimension === 'height' && height > 0) {
                vm.size.width = Math.max(1, Math.round(height * ratio));
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirm = function () {
            var width = positiveNumber(vm.size.width);
            var height = positiveNumber(vm.size.height);
            vm.invalid = !(width && height);
            if (vm.invalid) {
                return;
            }
            $uibModalInstance.close({ width: width, height: height });
        };

        function positiveNumber(value) {
            var number = parseFloat(value);
            return isFinite(number) && number > 0 ? Math.round(number * 100) / 100 : null;
        }
    }
})();
